import React from 'react';
import PropTypes from 'prop-types';

const Textarea = (props) => {
    let { onChange, name, label, value, ...rest } = props;

    return (
        <div className='float-label float-label__textarea'>
            <label className={`float-label__label${value !== '' ? ' float-label__label-out' : ''}`}
                htmlFor={`txt${name}`}>
                {label}
            </label>
            <textarea
                {...rest}
                id={`txt${name}`}
                defaultValue={value}
                onChange={onChange} />
        </div>
    );
}

Textarea.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export default Textarea;